import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";

import AdminNavBar from "../../NavBar/AdminNavBar";
import style from './AllPayRoll.module.css';
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function AllPayroll() {

    const [users, setUsers] = useState([]);
    const [payrolls, setPayrolls] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1);
    const payrollsPerPage = 10;

    const token = localStorage.getItem("token");
    const { employeeId: adminId } = useParams();
    const apiUrl = process.env.REACT_APP_SERVER_URL;

    // Fetch payrolls
    const FetchPayroll = async () => {
        try {
            const res = await fetch(`${apiUrl}/payroll/users/all-payroll`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
            const data = await res.json();
            setLoading(false)
            setPayrolls(data.payrolls || []);
        } catch (error) {
            setError(error.message);
            setLoading(true)
        }
    };

    // Fetch users
    const fetchUsers = async () => {
        try {
            const res = await fetch(`${apiUrl}/users`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
            const data = await res.json();
            setUsers(data.users || []);
        } catch (error) {
            setError(error.message);
        }
    };

    // Pagination logic
    const indexOfLast = currentPage * payrollsPerPage;
    const indexOfFirst = indexOfLast - payrollsPerPage;
    const currentUsers = users.slice(indexOfFirst, indexOfLast); // paginate users
    const totalPages = Math.ceil(users.length / payrollsPerPage);

    // handle pagination next 
    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
    };

    // handle pagination prev
    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(prev => prev - 1);
    };

    useEffect(() => {
        fetchUsers();
        FetchPayroll();
    }, [apiUrl]);

    return (
        <div className="container pb-1">
            <div className={style.payrollPage}>
                <AdminNavBar />

                {/* error component */}
                {error && <p className="text-danger">{error}</p>}
                <div className="row pt-lg-4">

                    {/* BreadCrumb Linkss */}
                    <div className="col-5 col-lg-5 ">
                        <BreadCrumb
                            link={`/admin-dashboard/${adminId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/admin-dashboard/${adminId}/all-payrolls`}
                            name="All Payrolls"
                        />
                    </div>
                    <div className="col-3 col-lg-5"></div>
                    <div className="col-4 col-lg-2 text-end pt-1">
                        <p className={`${style.breadcrumb}  `}>Payrolls: <b>{users.length}</b></p>
                    </div>
                </div>

                <div className=' pt-2 table-responsive'>
                    <table className="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <th className="text-center">Employee Id</th>
                                <th className="text-center">Name</th>
                                <th className="text-center">Designation</th>
                                <th className="text-center">Gross Salary</th>
                                <th className="text-center">Base Salary</th>
                                <th className="text-center">Bonus</th>
                                <th className="text-center">Deducations</th>
                                <th className="text-center">Allowances</th>
                                <th className="text-center">Net Salary</th>
                                <th className="text-center">Update/Create</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ?
                                    <>
                                        {Array.from({ length: 10 }).map((_, idx) => {
                                            return (
                                                <>
                                                    <tr key={idx} >
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        })}
                                    </>
                                    :
                                    <>
                                        {currentUsers.map((user) => {
                                            // match payroll by employeeId
                                            const payroll = payrolls.find((p) => p.employeeId === user.employeeId);

                                            return (
                                                <tr key={user._id}>
                                                    <td className="text-center">{user.employeeId}</td>
                                                    <td className="text-center  text-capitalize">{user.firstName} {user.LastName}</td>
                                                    <td className="text-center  text-capitalize">{user.position}</td>
                                                    <td className="text-center"> {payroll?.grossSalary ? payroll.grossSalary.toLocaleString("en-IN") : "Pending"} </td>
                                                    <td className="text-center">{payroll?.baseSalary ? payroll.baseSalary.toLocaleString("en-IN") : "Pending"}</td>
                                                    <td className="text-center">{payroll?.bonus ? payroll.bonus.toLocaleString("en-IN") : "Pending"}</td>
                                                    <td className="text-center">{payroll?.deductions ? payroll.deductions.toLocaleString("en-IN") : "Pending"}</td>
                                                    <td className="text-center">{payroll?.allowances ? payroll.allowances.toLocaleString("en-IN") : "Pending"}</td>
                                                    <td className="text-center">{payroll?.netSalary ? payroll.netSalary.toLocaleString("en-IN") : "Pending"}</td>
                                                    <td className="text-center">
                                                        {payroll ? (
                                                            <Link to={`/admin-dashboard/${adminId}/payroll/update-payroll/${user.employeeId}`} className="text-warning" style={{ textDecoration: 'none' }}>Update</Link>
                                                        ) : (
                                                            <Link to={`/admin-dashboard/${adminId}/payroll/create-payroll/${user.employeeId}`} className="text-primary " style={{ textDecoration: 'none' }}>Create </Link>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </>
                            }
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="row mb-5 mt-3 pb-lg-3">
                    <div className="col-12 text-center">
                        <button
                            style={{ border: "none" }}
                            className="btn mx-2"
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                        >
                            <b>{"<<"}</b>
                        </button>
                        <span className="mx-2">
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            style={{ border: "none" }}
                            className="btn mx-2"
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                        >
                            <b>{">>"}</b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
